import { render } from "./InsuranceClaims.vue?vue&type=template&id=1d53769a&scoped=true"
import script from "./InsuranceClaims.vue?vue&type=script&lang=js"
export * from "./InsuranceClaims.vue?vue&type=script&lang=js"

import "./InsuranceClaims.vue?vue&type=style&index=0&id=1d53769a&lang=css"
import "./InsuranceClaims.vue?vue&type=style&index=1&id=1d53769a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d53769a"]])

export default __exports__